import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpModule } from '@api/http';

@NgModule({
	imports: [CommonModule, HttpModule]
})
export class ExternalTransferModule {}
